import type { TournamentDrawType } from 'types/tournament';

const newCompetition = (newFitId: string) => {
  const url = `https://www.fitp.it/Tornei/Dettaglio-Competizione?competitionId=${newFitId}#`;
  return url;
};

const championship = (newFitId: string) => {
  const url = `https://www.fitp.it/Tornei/Campionato-a-squadre-dettagli?competitionId=${newFitId}`;
  return url;
};

const draw = (fitDrawId: string | undefined, tournament: TournamentDrawType | undefined) =>
  `https://www.fitp.it/Tornei/Areas/Federtennis/Scripts/Puc/Tabellone_v2?tournamentId=${tournament?.new_fit_tournament_id}&phaseId=${fitDrawId}`;

const fitPlayerUrl = (cardNumber: string) => `https://management.federtennis.it/vt?k=${cardNumber}&y=CT`;

export default {
  draw,
  fitPlayerUrl,
  newCompetition,
  championship,
};
